import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable()
export class SociallogService {
  constructor(private http: HttpClient) {}

  socialLogin(socialUser, adsClickObj) {
    if (adsClickObj) {
      socialUser.adsClickObj = adsClickObj;
    }
    const url = `${environment.apiUrl}/users/sociallogin`;
    return this.http.post<any>(url, socialUser);
  }
}
